import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Trophy, Sun, Moon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

const HERO_BG = 'https://images.unsplash.com/photo-1578720434255-8a9142b95c07?w=1920&h=1080&fit=crop';

export default function Landing() {
    const { theme, toggleTheme } = useTheme();

    return (
        <div className="min-h-screen bg-background">
            {/* Theme toggle - top right */}
            <button
                onClick={toggleTheme}
                className="fixed top-5 right-5 z-50 w-10 h-10 rounded-xl bg-white/10 backdrop-blur-md border border-white/20 flex items-center justify-center transition-all hover:bg-white/20 active:scale-90"
                data-testid="landing-theme-toggle"
            >
                {theme === 'dark' ? <Sun className="w-5 h-5 text-amber-400" /> : <Moon className="w-5 h-5 text-white" />}
            </button>
            {/* Hero Section - Full Screen */}
            <section 
                className="relative min-h-screen flex items-center justify-center hero-bg"
                style={{ backgroundImage: `url(${HERO_BG})` }}
            >
                <div className="relative z-10 max-w-4xl mx-auto px-4 text-center">
                    <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20 mb-6 animate-fade-in">
                        <Trophy className="w-4 h-4 text-primary" />
                        <span className="text-sm font-medium text-primary">Plataforma de Predicciones</span>
                    </div>
                    
                    <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl font-black tracking-tight mb-6 animate-fade-in stagger-1 text-white">
                        ¿Ya compraste en
                        <span className="block text-primary">Remakia.com?</span>
                    </h1>
                    
                    <p className="text-lg sm:text-xl text-gray-300 max-w-2xl mx-auto mb-8 animate-fade-in stagger-2">
                        Entonces estás listo, entra con tu mismo correo y registra tu predicción para el mundial.
                    </p>
                    
                    <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in stagger-3">
                        <Link to="/login">
                            <Button 
                                variant="outline" 
                                size="lg"
                                className="rounded-md text-lg px-8 py-6 w-full sm:w-auto btn-glow animate-pulse-glow text-white border-primary border-2 bg-primary/20 hover:bg-primary hover:text-white transition-all duration-300"
                                data-testid="hero-login-btn"
                            >
                                Iniciar Sesión
                            </Button>
                        </Link>
                    </div>
                </div>

                {/* Scroll indicator */}
                <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
                    <div className="w-6 h-10 rounded-full border-2 border-white/30 flex justify-center pt-2">
                        <div className="w-1.5 h-1.5 rounded-full bg-white/50" />
                    </div>
                </div>
            </section>
        </div>
    );
}
